module.exports = __webpack_public_path__ + "static/media/Tiempo.1bfbccf0.svg";